// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"ArrowButtons_noScrolling__wlJT0","button":"ArrowButtons_button__bT4HB","prev":"ArrowButtons_prev__Nwa2N","next":"ArrowButtons_next__AemoG"};